/* FuryX Studios — storefront behaviours. Vanilla, no dependencies. */
(function () {
  'use strict';

  var on = function (el, ev, fn, opts) { el.addEventListener(ev, fn, opts); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var $ = function (sel, root) { return (root || document).querySelector(sel); };

  /* Horizon puts the page inside a scrolling <div class="page-wrapper"> and
     sets overflow:hidden on html/body, so window.pageYOffset stays 0. Anything
     that reads scroll position has to find the real scroller first. */
  function scrollerOf(el) {
    var p = el.parentElement;
    while (p && p !== document.body && p !== document.documentElement) {
      var cs = getComputedStyle(p);
      if (/(auto|scroll)/.test(cs.overflowY) && p.scrollHeight > p.clientHeight + 4) return p;
      p = p.parentElement;
    }
    return null;
  }

  /* ---------------------------------------------------------- marquee */
  function initMarquee(root) {
    var track = $('.fx-marquee__track', root);
    if (!track || track.dataset.fxCloned) return;
    track.dataset.fxCloned = '1';
    track.innerHTML = track.innerHTML + track.innerHTML;
  }

  /* ---------------------------------------------------------- tab groups */
  function initTabs(root) {
    var group = root.dataset.fxTabs || '';
    function targets() {
      return $$('[data-fx-target]').filter(function (p) {
        return (p.dataset.fxGroup || '') === group;
      });
    }
    function select(i) {
      $$('[data-fx-tab]', root).forEach(function (b) {
        var isOn = b.dataset.fxTab === i;
        b.classList.toggle('is-on', isOn);
        b.setAttribute('aria-selected', isOn ? 'true' : 'false');
      });
      targets().forEach(function (p) {
        p.classList.toggle('is-on', p.dataset.fxTarget === i);
      });
      root.dataset.fxActive = i;
    }
    $$('[data-fx-tab]', root).forEach(function (b) {
      on(b, 'click', function () { select(b.dataset.fxTab); });
    });
    select(root.dataset.fxActive || '0');
  }

  /* ---------------------------------------------------------- pinned scene */
  function initScene(wrap) {
    var group = wrap.dataset.fxGroup || '';
    var rows = $$('[data-fx-tab]', wrap);
    var n = rows.length;
    if (!n) return;

    var sc = scrollerOf(wrap);
    var host = sc || window;

    function pinned() { return window.matchMedia('(min-width: 1000px)').matches; }
    function viewH() { return sc ? sc.clientHeight : window.innerHeight; }
    function scrollY() { return sc ? sc.scrollTop : window.pageYOffset; }
    function offsetTop() {
      var r = wrap.getBoundingClientRect();
      if (!sc) return window.pageYOffset + r.top;
      return sc.scrollTop + (r.top - sc.getBoundingClientRect().top);
    }
    function span() { return wrap.offsetHeight - viewH(); }
    function targets() {
      return $$('[data-fx-target]', wrap).filter(function (p) {
        return (p.dataset.fxGroup || '') === group;
      });
    }

    var last = -1;
    function select(i) {
      if (i === last) return;
      last = i;
      rows.forEach(function (b, k) {
        b.classList.toggle('is-on', k === i);
        b.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
      targets().forEach(function (p) {
        p.classList.toggle('is-on', parseInt(p.dataset.fxTarget, 10) === i);
      });
      wrap.dataset.fxActive = String(i);
    }

    var queued = false;
    function tick() {
      queued = false;
      if (!pinned()) return;
      var total = span();
      if (total <= 0) return;
      var p = (scrollY() - offsetTop()) / total;
      if (p < 0) p = 0;
      if (p > 0.9999) p = 0.9999;
      select(Math.floor(p * n));
    }
    function schedule() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(tick);
    }

    rows.forEach(function (b, k) {
      on(b, 'click', function () {
        if (!pinned()) { select(k); return; }
        var y = offsetTop() + ((k + 0.5) / n) * span();
        if (sc && sc.scrollTo) { sc.scrollTo({ top: y, behavior: 'smooth' }); }
        else { window.scrollTo({ top: y, behavior: 'smooth' }); }
      });
    });

    on(host, 'scroll', schedule, { passive: true });
    on(window, 'resize', function () { last = -1; schedule(); });
    select(0);
    schedule();
  }

  /* ---------------------------------------------------------- build chapter
     The media column is sticky; whichever step sits in the middle band of the
     viewport decides which photograph is showing. */
  function initBuild(root) {
    var steps = $$('[data-fx-step]', root);
    var shots = $$('[data-fx-shot]', root);
    if (!steps.length) return;

    var cur = -1;
    function set(i) {
      if (i === cur || i < 0) return;
      cur = i;
      steps.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      shots.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
    }

    if (!('IntersectionObserver' in window)) { set(0); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) set(steps.indexOf(e.target));
      });
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
    steps.forEach(function (s) { io.observe(s); });
    set(0);
  }

  /* ---------------------------------------------------------- accordion */
  function initFaq(root) {
    var items = $$('.fx-faq__item', root);
    items.forEach(function (item) {
      var q = $('.fx-faq__q', item);
      if (!q) return;
      on(q, 'click', function () {
        var open = item.classList.contains('is-open');
        items.forEach(function (o) {
          o.classList.remove('is-open');
          var ob = $('.fx-faq__q', o);
          if (ob) ob.setAttribute('aria-expanded', 'false');
        });
        item.classList.toggle('is-open', !open);
        q.setAttribute('aria-expanded', String(!open));
      });
    });
  }

  /* ---------------------------------------------------------- carousel */
  function initCarousel(root) {
    var track = $('.fx-doss__track', root);
    var prev = $('[data-fx-prev]', root);
    var next = $('[data-fx-next]', root);
    if (!track) return;
    var i = 0;
    function step() {
      var card = track.firstElementChild;
      if (!card) return 0;
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 20;
      return card.getBoundingClientRect().width + gap;
    }
    function maxIndex() {
      var vp = track.parentElement.getBoundingClientRect().width;
      var s = step();
      if (!s) return 0;
      return Math.max(0, Math.ceil((track.scrollWidth - vp) / s));
    }
    function render() {
      var m = maxIndex();
      if (i > m) i = m;
      if (i < 0) i = 0;
      track.style.transform = 'translateX(-' + (i * step()) + 'px)';
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= m;
    }
    if (prev) on(prev, 'click', function () { i -= 1; render(); });
    if (next) on(next, 'click', function () { i += 1; render(); });
    on(window, 'resize', render);
    render();
  }

  /* ---------------------------------------------------------- number picker */
  function initEngrave(root) {
    var out = $('[data-fx-num]', root);
    var status = $('[data-fx-status]', root);
    var shuffle = $('[data-fx-shuffle]', root);
    var claim = $('[data-fx-claim]', root);
    if (!out) return;

    var total = parseInt(root.dataset.fxTotal, 10) || 180;
    var taken = (root.dataset.fxTaken || '').split(',')
      .map(function (s) { return parseInt(s.trim(), 10); })
      .filter(function (n) { return !isNaN(n); });

    var pool = [];
    for (var n = 1; n <= total; n++) if (taken.indexOf(n) === -1) pool.push(n);
    if (!pool.length) pool = [1];

    var pad = function (v) { return '#' + String(v).padStart(3, '0'); };
    var pick = function () { return pool[Math.floor(Math.random() * pool.length)]; };
    var current = pick();

    function paint(v, claimed) {
      current = v;
      out.textContent = pad(v);
      root.classList.toggle('is-claimed', !!claimed);
      if (status) status.textContent = claimed
        ? (root.dataset.fxClaimedText || 'Yours — this number goes on the order')
        : (root.dataset.fxFreeText || 'Available — not claimed yet');
      if (claim) {
        claim.textContent = claimed
          ? (root.dataset.fxClaimedLabel || 'Continue →')
          : (root.dataset.fxClaimLabel || 'Take this number');
        var href = root.dataset.fxUrl;
        if (href) {
          claim.setAttribute('href', href + (href.indexOf('?') > -1 ? '&' : '?') + 'engraving=' + String(v).padStart(3, '0'));
        }
      }
    }

    function roll() {
      if (out.dataset.rolling) return;
      out.dataset.rolling = '1';
      out.classList.add('is-rolling');
      var ticks = 0;
      var timer = setInterval(function () {
        out.textContent = pad(pick());
        ticks += 1;
        if (ticks > 11) {
          clearInterval(timer);
          out.classList.remove('is-rolling');
          delete out.dataset.rolling;
          paint(pick(), false);
        }
      }, 55);
    }

    if (shuffle) on(shuffle, 'click', function (e) { e.preventDefault(); roll(); });
    if (claim) on(claim, 'click', function () { paint(current, true); });
    paint(current, false);
  }

  /* ---------------------------------------------------------- product */
  function initProduct(root) {
    var dataEl = $('[data-fx-variant-json]', root);
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var idInput = $('[data-fx-variant-id]', root);
    var priceEl = $('[data-fx-price]', root);
    var nameEls = $$('[data-fx-variant-name]', root);
    var addBtn = $('[data-fx-add]', root);
    var stage = $('[data-fx-stage]', root);
    var stockEl = $('[data-fx-stock]', root);
    var swatches = $$('.fx-swatch', root);

    function money(cents) {
      if (window.Shopify && Shopify.formatMoney && window.fxMoneyFormat) {
        return Shopify.formatMoney(cents, window.fxMoneyFormat);
      }
      var v = (cents / 100).toFixed(2);
      if (v.slice(-3) === '.00') v = v.slice(0, -3);
      return '€' + v;
    }

    /* Three states, not two: in stock, orderable but nothing on the shelf,
       and sold out. Without the middle one the page says "0 in stock". */
    function stockLine(v) {
      if (!v.available) return root.dataset.fxOutStock || 'Sold out';
      if (v.inventory > 0) {
        return (root.dataset.fxInStock || '[qty] in stock').replace('[qty]', v.inventory);
      }
      return root.dataset.fxBackorder || 'Available to order';
    }

    function select(id) {
      var v = null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) { v = variants[i]; break; }
      }
      if (!v) v = variants[0];

      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      nameEls.forEach(function (el) { el.textContent = v.title; });
      if (stage && v.stage) stage.style.background = v.stage;
      if (stockEl) stockEl.textContent = stockLine(v);
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available
          ? (root.dataset.fxAddLabel || 'Add to bag') + ' — ' + money(v.price)
          : (root.dataset.fxOutStock || 'Sold out');
      }
      swatches.forEach(function (s) {
        var isOn = String(s.dataset.fxVariant) === String(v.id);
        s.classList.toggle('is-on', isOn);
        s.setAttribute('aria-checked', isOn ? 'true' : 'false');
      });
      if (window.history && history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u.toString());
        } catch (e) { /* older browsers */ }
      }
    }

    swatches.forEach(function (s) {
      on(s, 'click', function () { select(s.dataset.fxVariant); });
    });

    var initial = null;
    try { initial = new URL(window.location.href).searchParams.get('variant'); } catch (e) {}
    if (!initial && idInput) initial = idInput.value;
    if (!initial) initial = variants[0].id;
    select(initial);

    /* number carried over from the homepage picker */
    var field = $('[data-fx-engraving-field]', root);
    var badge = $('[data-fx-engraving-badge]', root);
    var q = null;
    try { q = new URL(window.location.href).searchParams.get('engraving'); } catch (e) {}
    if (q && /^[0-9]{1,3}$/.test(q)) {
      var label = '#' + q.padStart(3, '0');
      if (field) field.value = label;
      if (badge) badge.textContent = label;
    } else if (badge && field) {
      badge.textContent = field.value || '';
    }
    if (field && badge) {
      on(field, 'input', function () { badge.textContent = field.value; });
    }
  }

  /* ---------------------------------------------------------- boot */
  function boot(scope) {
    $$('.fx-marquee', scope).forEach(initMarquee);
    $$('[data-fx-tabs]', scope).forEach(initTabs);
    $$('[data-fx-scene]', scope).forEach(initScene);
    $$('[data-fx-build]', scope).forEach(initBuild);
    $$('[data-fx-faq]', scope).forEach(initFaq);
    $$('[data-fx-carousel]', scope).forEach(initCarousel);
    $$('[data-fx-engrave]', scope).forEach(initEngrave);
    $$('[data-fx-product]', scope).forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    on(document, 'DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  on(document, 'shopify:section:load', function (e) { boot(e.target); });
})();